import {useEffect} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {FAVOURITES_TOPBAR_AB_TEST_ID, FAVOURITES_TOPBAR_CONTROL_VARIANT, FAVOURITES_TOPBAR_TREATMENT_VARIANT} from "../../ab_testing/favourites_topbar_ab_test";

let hasTrackedExposure = false;

export const useFavouritesTopbarExperiment = (options?: {trackExposure?: boolean}) => {
    const {trackExposure = false} = options ?? {};
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: FAVOURITES_TOPBAR_AB_TEST_ID,
        variants: [FAVOURITES_TOPBAR_CONTROL_VARIANT, FAVOURITES_TOPBAR_TREATMENT_VARIANT],
        withSSR: true,
        pushEventOnlyOnce: true
    });
    const hasAssignedVariant =
        canABTestBeRendered && (abTestVariant === FAVOURITES_TOPBAR_CONTROL_VARIANT || abTestVariant === FAVOURITES_TOPBAR_TREATMENT_VARIANT);

    useEffect(() => {
        if (!trackExposure || !hasAssignedVariant || hasTrackedExposure) {
            return;
        }

        hasTrackedExposure = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(FAVOURITES_TOPBAR_AB_TEST_ID));
    }, [hasAssignedVariant, trackExposure]);

    return {
        isFavouritesTopbarTreatment: hasAssignedVariant && abTestVariant === FAVOURITES_TOPBAR_TREATMENT_VARIANT,
        variant: abTestVariant
    };
};
import {useEffect} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {FAVOURITES_TOPBAR_AB_TEST_ID, FAVOURITES_TOPBAR_CONTROL_VARIANT, FAVOURITES_TOPBAR_TREATMENT_VARIANT} from "../../ab_testing/favourites_topbar_ab_test";

let hasTrackedExposure = false;

export const useFavouritesTopbarExperiment = (options?: {trackExposure?: boolean}) => {
    const {trackExposure = false} = options ?? {};
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: FAVOURITES_TOPBAR_AB_TEST_ID,
        variants: [FAVOURITES_TOPBAR_CONTROL_VARIANT, FAVOURITES_TOPBAR_TREATMENT_VARIANT],
        withSSR: true,
        pushEventOnlyOnce: true
    });
    const hasAssignedVariant =
        canABTestBeRendered && (abTestVariant === FAVOURITES_TOPBAR_CONTROL_VARIANT || abTestVariant === FAVOURITES_TOPBAR_TREATMENT_VARIANT);

    useEffect(() => {
        if (!trackExposure || !hasAssignedVariant || hasTrackedExposure) {
            return;
        }

        hasTrackedExposure = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(FAVOURITES_TOPBAR_AB_TEST_ID));
    }, [hasAssignedVariant, trackExposure]);

    return {
        isFavouritesTopbarTreatment: hasAssignedVariant && abTestVariant === FAVOURITES_TOPBAR_TREATMENT_VARIANT,
        variant: abTestVariant
    };
};
